import { render } from "./ConfirmTarget.vue?vue&type=template&id=08b59278&scoped=true"
import script from "./ConfirmTarget.vue?vue&type=script&lang=js"
export * from "./ConfirmTarget.vue?vue&type=script&lang=js"

import "./ConfirmTarget.vue?vue&type=style&index=0&id=08b59278&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b59278"]])

export default __exports__